import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MessagingChannelHelperService } from '../messaging-channel-helper.service'

@Component({
  selector: 'app-connect-instagram-dialog',
  templateUrl: './connect-instagram-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./connect-instagram-dialog.component.scss'],
})
export class ConnectInstagramDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConnectInstagramDialogComponent>,
    private helper: MessagingChannelHelperService
  ) {}

  close() {
    this.dialogRef.close()
  }

  onConnect() {
    this.helper.connect('instagram').subscribe(() => {
      this.close()
    })
  }
}
